// src/appearance.js
// Пользовательские настройки внешнего вида: тема и режим пониженной анимации.
// Состояние хранится в localStorage и отражается атрибутами на <html>,
// чтобы CSS (theme.css) реагировал без перерисовки React-дерева.

const THEME_KEY = 'eu_theme';            // 'light' | 'dark'
const MOTION_KEY = 'eu_reduce_motion';   // 'on' | 'off'

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function read(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    /* приватный режим — настройка просто не сохранится */
  }
}

export function getTheme() {
  const saved = read(THEME_KEY);
  if (saved === 'dark' || saved === 'light') return saved;
  // По умолчанию — светлая тема: тёмную пользователь включает сам,
  // чтобы вид сайта не поменялся разом у всех из-за настроек ОС.
  return 'light';
}

export function getReduceMotion() {
  const saved = read(MOTION_KEY);
  if (saved === 'on') return true;
  if (saved === 'off') return false;
  return prefersReducedMotion();
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.style.backgroundColor =
    theme === 'dark' ? '#131920' : '';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'dark' ? '#171f29' : '#ffffff');
}

export function applyReduceMotion(enabled) {
  document.documentElement.setAttribute('data-reduce-motion', enabled ? 'on' : 'off');
}

export function setTheme(theme) {
  write(THEME_KEY, theme);
  applyTheme(theme);
}

export function setReduceMotion(enabled) {
  write(MOTION_KEY, enabled ? 'on' : 'off');
  applyReduceMotion(enabled);
}

// Применяем сохранённые настройки как можно раньше — до первого рендера.
export function initAppearance() {
  applyTheme(getTheme());
  applyReduceMotion(getReduceMotion());
}
